<template>
  <div class="report">
    <v-row>
      <v-col class="document-title">
        <h1>Dnevnik prodaje</h1>
      </v-col>
    </v-row>
    <ReportPrintAllHeader :params="params" />

    <div v-for="day in daily" :key="day.date">
      <v-row class="table-title">
        <v-col>
          Promet na dan: {{sloDate(day.date)}}
        </v-col>
      </v-row>

      <v-row class="table-header-daily">
        <v-col cols="2" class="font-weight-bold">
          NAPRAVA
        </v-col>
        <v-col class="font-weight-bold">
          RAČUNI
        </v-col>
        <v-col>
          <div class="full-width text-center font-weight-bold">
            OSNOVA
          </div>
          <div class="full-width text-center">
            DDV
          </div>
        </v-col>
        <v-col>
          <div class="full-width text-center font-weight-bold">
            OSNOVA 9,5%
          </div>
          <div class="full-width text-center">
            DDV 9,5%
          </div>
        </v-col>
        <v-col>
          <div class="full-width text-center font-weight-bold">
            OSNOVA 22%
          </div>
          <div class="full-width text-center">
            DDV 22%
          </div>
        </v-col>
        <v-col>
          <div class="full-width text-center font-weight-bold">
            NEOBDAV. PROMET
          </div>
        </v-col>
        <v-col cols="2" class="text-right font-weight-bold">
          SKUPAJ (BRUTO)
        </v-col>
      </v-row>

      <v-row v-for="device in day.devices" :key="device.name">
        <v-col cols="2" class="font-weight-bold">
          {{device.name}}
        </v-col>
        <v-col>
          {{device.minInvoiceNumber}} - {{device.maxInvoiceNumber}}
        </v-col>
        <v-col>
          <div class="full-width text-center font-weight-bold" :inner-html.prop="device.taxable_amount_total | price(2)">
          </div>
          <div class="full-width text-center" :inner-html.prop="device.tax_amount_total | price(2)">
          </div>
        </v-col>
        <v-col>
          <div class="full-width text-center font-weight-bold" :inner-html.prop="device.taxLevels['9.5'].taxable_amount | price(2)" v-if="device.taxLevels && device.taxLevels['9.5'] && device.taxLevels['9.5'].taxable_amount">
          </div>
          <div class="full-width text-center" :inner-html.prop="device.taxLevels['9.5'].tax_amount | price(2)" v-if="device.taxLevels && device.taxLevels['9.5'] && device.taxLevels['9.5'].tax_amount">
          </div>
        </v-col>
        <v-col>
          <div class="full-width text-center font-weight-bold" :inner-html.prop="device.taxLevels['22'].taxable_amount | price(2)" v-if="device.taxLevels && device.taxLevels['22'] && device.taxLevels['22'].taxable_amount">
          </div>
          <div class="full-width text-center" :inner-html.prop="device.taxLevels['22'].tax_amount | price(2)" v-if="device.taxLevels && device.taxLevels['22'] && device.taxLevels['22'].tax_amount">
          </div>
        </v-col>
        <v-col>
          <div class="full-width text-center font-weight-bold" :inner-html.prop="nontaxableTotal(device) | price(2)" v-if="nontaxableTotal(device) !== null">
          </div>
          <div class="full-width text-center">
          </div>
        </v-col>
        <v-col cols="2">
          <div class="full-width text-right font-weight-bold" :inner-html.prop="device.total | price(2)">
          </div>
          <div class="full-width text-right">
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" offset="2" class="py-0">
          <v-row class="table-footer-daily">
            <v-col class="font-weight-bold">
              SKUPAJ
            </v-col>
            <v-col>
              <div class="full-width text-center font-weight-bold" :inner-html.prop="devicesTaxable_amount_total(day.devices) | price(2)">
              </div>
              <div class="full-width text-center" :inner-html.prop="devicesTax_amount_total(day.devices) | price(2)">
              </div>
            </v-col>
            <v-col>
              <div class="full-width text-center font-weight-bold" :inner-html.prop="devicesTaxLevels95(day.devices).taxable_amount | price(2)" v-if="devicesTaxLevels95(day.devices)">
              </div>
              <div class="full-width text-center" :inner-html.prop="devicesTaxLevels95(day.devices).tax_amount | price(2)" v-if="devicesTaxLevels95(day.devices)">
              </div>
            </v-col>
            <v-col>
              <div class="full-width text-center font-weight-bold" :inner-html.prop="devicesTaxLevels22(day.devices).taxable_amount | price(2)" v-if="devicesTaxLevels22(day.devices)">
              </div>
              <div class="full-width text-center" :inner-html.prop="devicesTaxLevels22(day.devices).tax_amount | price(2)" v-if="devicesTaxLevels22(day.devices)">
              </div>
            </v-col>
            <v-col style="padding-right: 30px;">
              <div class="full-width text-center font-weight-bold" :inner-html.prop="devicesNontaxableTotal(day.devices) | price(2)" v-if="devicesNontaxableTotal(day.devices) !== null">
              </div>
              <div class="full-width text-center">
              </div>
            </v-col>
            <v-col cols="2" class="text-right font-weight-bold" :inner-html.prop="devicesTotal(day.devices) | price(2)">
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <br>
      <br>
      <br>
    </div>

    <v-row>
      <v-col class="document-title">
        <h1>Dnevnik prodaje skupaj</h1>
      </v-col>
    </v-row>

    <v-row class="table-title">
      <v-col>
        Promet za obdobje: {{reportDateFrom}} - {{reportDateTo}}
      </v-col>
    </v-row>

    <v-row class="table-header-daily">
      <v-col cols="2" class="font-weight-bold">
        NAPRAVA
      </v-col>
      <v-col class="font-weight-bold">
        RAČUNI
      </v-col>
      <v-col>
        <div class="full-width text-center font-weight-bold">
          OSNOVA
        </div>
        <div class="full-width text-center">
          DDV
        </div>
      </v-col>
      <v-col>
        <div class="full-width text-center font-weight-bold">
          OSNOVA 9,5%
        </div>
        <div class="full-width text-center">
          DDV 9,5%
        </div>
      </v-col>
      <v-col>
        <div class="full-width text-center font-weight-bold">
          OSNOVA 22%
        </div>
        <div class="full-width text-center">
          DDV 22%
        </div>
      </v-col>
      <v-col>
        <div class="full-width text-center font-weight-bold">
          NEOBDAV. PROMET
        </div>
      </v-col>
      <v-col cols="2" class="text-right font-weight-bold">
        SKUPAJ (BRUTO)
      </v-col>
    </v-row>

    <v-row v-for="device of dailySummed" :key="device.name">
      <v-col cols="2" class="font-weight-bold">
        {{device.name}}
      </v-col>
      <v-col>
        {{device.minInvoiceNumber}} - {{device.maxInvoiceNumber}}
      </v-col>
      <v-col>
        <div class="full-width text-center font-weight-bold" :inner-html.prop="device.taxable_amount_total | price(2)">
        </div>
        <div class="full-width text-center" :inner-html.prop="device.tax_amount_total | price(2)">
        </div>
      </v-col>
      <v-col>
        <div class="full-width text-center font-weight-bold" :inner-html.prop="device.taxLevels['9.5'].taxable_amount | price(2)" v-if="device.taxLevels && device.taxLevels['9.5'] && device.taxLevels['9.5'].taxable_amount">
        </div>
        <div class="full-width text-center" :inner-html.prop="device.taxLevels['9.5'].tax_amount | price(2)" v-if="device.taxLevels && device.taxLevels['9.5'] && device.taxLevels['9.5'].tax_amount">
        </div>
      </v-col>
      <v-col>
        <div class="full-width text-center font-weight-bold" :inner-html.prop="device.taxLevels['22'].taxable_amount | price(2)" v-if="device.taxLevels && device.taxLevels['22'] && device.taxLevels['22'].taxable_amount">
        </div>
        <div class="full-width text-center" :inner-html.prop="device.taxLevels['22'].tax_amount | price(2)" v-if="device.taxLevels && device.taxLevels['22'] && device.taxLevels['22'].tax_amount">
        </div>
      </v-col>
      <v-col>
        <div class="full-width text-center font-weight-bold" :inner-html.prop="nontaxableTotal(device) | price(2)" v-if="nontaxableTotal(device) !== null">
        </div>
        <div class="full-width text-center">
        </div>
      </v-col>
      <v-col cols="2" class="text-right font-weight-bold" :inner-html.prop="device.total | price(2)">
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="10" offset="2" class="py-0">
        <v-row class="table-footer-daily">
          <v-col class="font-weight-bold">
            SKUPAJ
          </v-col>

          <v-col>
            <div class="full-width text-center font-weight-bold" :inner-html.prop="dailySummedTaxableAmountTotalSum | price(2)">
            </div>
            <div class="full-width text-center" :inner-html.prop="dailySummedTaxAmountTotalSum | price(2)">
            </div>
          </v-col>
          <v-col>
            <div class="full-width text-center font-weight-bold" :inner-html.prop="dailySummedTaxLevelsSum['9.5'].taxable_amount | price(2)" v-if="dailySummedTaxLevelsSum['9.5']">
            </div>
            <div class="full-width text-center" :inner-html.prop="dailySummedTaxLevelsSum['9.5'].tax_amount | price(2)" v-if="dailySummedTaxLevelsSum['9.5']">
            </div>
          </v-col>
          <v-col>
            <div class="full-width text-center font-weight-bold" :inner-html.prop="dailySummedTaxLevelsSum['22'].taxable_amount | price(2)" v-if="dailySummedTaxLevelsSum['22']">
            </div>
            <div class="full-width text-center" :inner-html.prop="dailySummedTaxLevelsSum['22'].tax_amount | price(2)" v-if="dailySummedTaxLevelsSum['22']">
            </div>
          </v-col>
          <v-col style="padding-right: 30px;">
            <div class="full-width text-center font-weight-bold" :inner-html.prop="dailySummedNontaxableTotal | price(2)" v-if="dailySummedNontaxableTotal !== null">
            </div>
            <div class="full-width text-center">
            </div>
          </v-col>
          <v-col cols="2" class="text-right font-weight-bold" :inner-html.prop="dailySummedTotalSum | price(2)">
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <br>
    <br>
    <br>

    <v-row>
      <v-col cols="4" offset="4" class="table-title">
        Po plačilnih sredstvih
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="10" offset="2" class="py-0">
        <v-row class="table-header">
          <v-col cols="2">
            PL. SREDSTVO
          </v-col>
          <v-col>
            NETO
          </v-col>
          <v-col>
            DDV 9,5%
          </v-col>
          <v-col>
            DDV 22%
          </v-col>
          <v-col>
            DDV SKUPAJ
          </v-col>
          <v-col cols="2" class="text-right">
            SKUPAJ Z DDV
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10" offset="2" class="py-0">
        <v-row v-for="paymentMethod of totalsPaymentMethdos" :key="paymentMethod.name">
          <v-col cols="2" class="font-weight-bold">
            {{paymentMethod.name}}
          </v-col>
          <v-col :inner-html.prop="paymentMethod.taxableAmountTotal | price(2)">
          </v-col>
          <v-col :inner-html.prop="paymentMethod.taxLevels['9.5'] | price(2)">
          </v-col>
          <v-col :inner-html.prop="paymentMethod.taxLevels['22'] | price(2)">
          </v-col>
          <v-col :inner-html.prop="paymentMethod.taxAmountTotal | price(2)">
          </v-col>
          <v-col cols="2" class="text-right" :inner-html.prop="paymentMethod.total | price(2)">
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <br>
    <br>
    <br>

    <v-row>
      <v-col cols="4" offset="4" class="table-title">
        Po koristnikih
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="10" offset="2" class="py-0">
        <v-row class="table-header">
          <v-col cols="2">
            KORISTNIK
          </v-col>
          <v-col>
            NETO
          </v-col>
          <v-col>
            DDV 9,5%
          </v-col>
          <v-col>
            DDV 22%
          </v-col>
          <v-col>
            DDV SKUPAJ
          </v-col>
          <v-col cols="2" class="text-right">
            SKUPAJ Z DDV
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10" offset="2" class="py-0">
        <v-row>
          <v-col cols="2" class="font-weight-bold">
            Končni koristniki
          </v-col>
          <v-col :inner-html.prop="endBuyersTaxableAmountTotal | price(2)">
          </v-col>
          <v-col :inner-html.prop="endBuyersTaxLevels['9.5'] | price(2)">
          </v-col>
          <v-col :inner-html.prop="endBuyersTaxLevels['22'] | price(2)">
          </v-col>
          <v-col :inner-html.prop="endBuyersTaxAmountTotal | price(2)">
          </v-col>
          <v-col cols="2" class="text-right" :inner-html.prop="(endBuyersTaxableAmountTotal + endBuyersTaxAmountTotal) | price(2)">
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2" class="font-weight-bold">
            DDV zavezanci
          </v-col>
          <v-col :inner-html.prop="clientsTaxableAmountTotal | price(2)">
          </v-col>
          <v-col :inner-html.prop="clientsTaxLevels['9.5'] | price(2)">
          </v-col>
          <v-col :inner-html.prop="clientsTaxLevels['22'] | price(2)">
          </v-col>
          <v-col :inner-html.prop="clientsTaxAmountTotal | price(2)">
          </v-col>
          <v-col cols="2" class="text-right" :inner-html.prop="(clientsTaxableAmountTotal + clientsTaxAmountTotal) | price(2)">
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <br>
    <br>
    <br>

    <v-row>
      <v-col cols="4" offset="4" class="table-title">
        Po skupinah - DDV%
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="10" offset="2" class="py-0">
        <v-row class="table-header">
          <v-col cols="2">
            SKUPINA - DDV%
          </v-col>
          <v-col>
            NETO
          </v-col>
          <v-col></v-col>
          <v-col></v-col>
          <v-col>
            DDV SKUPAJ
          </v-col>
          <v-col cols="2" class="text-right">
            SKUPAJ Z DDV
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10" offset="2" class="py-0" v-for="group of totalsGroups" :key="group.name">
        <v-row>
          <v-col cols="2" class="font-weight-bold">
            {{group.name}} - {{group.tax_level_value}}%
          </v-col>
          <v-col :inner-html.prop="group.taxable_amount_total | price(2)">
          </v-col>
          <v-col></v-col>
          <v-col></v-col>
          <v-col :inner-html.prop="group.tax_amount_total | price(2)">
          </v-col>
          <v-col cols="2" class="text-right" :inner-html.prop="group.total | price(2)">
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment'
import ReportPrintAllHeader from './ReportPrintAllHeader'

export default {
  components: {
    ReportPrintAllHeader
  },
  props: {
    data: {
      required: true,
      type: Array
    },
    params: {
      required: true,
      type: Object
    }
  },
  computed: {
    reportDateFrom () {
      return moment(this.params.startDate + ' ' + this.params.startTime).format('DD.MM.YYYY')
    },
    reportDateTo () {
      return moment(this.params.endDate + ' ' + this.params.endTime).format('DD.MM.YYYY')
    },
    endBuyersTaxableAmountTotal () {
      return this.data.reduce((total, device) => total + device.totals.endBuyers.taxGroups.taxable_amount_total, 0)
    },
    endBuyersTaxAmountTotal () {
      return this.data.reduce((total, device) => total + device.totals.endBuyers.taxGroups.tax_amount_total, 0)
    },
    endBuyersTaxLevels () {
      const taxLevels = {}
      this.data.forEach(device => {
        device.totals.endBuyers.taxGroups.taxLevels.forEach(level => {
          taxLevels[level.tax_level_value] = taxLevels[level.tax_level_value] ? taxLevels[level.tax_level_value] + level.tax_amount : level.tax_amount
        })
      })
      return taxLevels
    },
    clientsTaxableAmountTotal () {
      return this.data.reduce((total, device) => total + device.totals.clients.taxGroups.taxable_amount_total, 0)
    },
    clientsTaxAmountTotal () {
      return this.data.reduce((total, device) => total + device.totals.clients.taxGroups.tax_amount_total, 0)
    },
    clientsTaxLevels () {
      const taxLevels = {}
      this.data.forEach(device => {
        device.totals.clients.taxGroups.taxLevels.forEach(level => {
          taxLevels[level.tax_level_value] = level.tax_amount
        })
      })
      return taxLevels
    },
    daily () {
      let days = {}
      this.data.forEach(device => {
        days = addDeviceToDays(device, days)
      })
      return Object.values(days).sort((a, b) => a.date > b.date ? 1 : -1)
    },
    totalsGroups () {
      let groups = {}
      this.data.forEach(device => {
        device.totals.groups.forEach(group => {
          if (groups[group.name]) {
            groups[group.name].name = group.name
            groups[group.name].tax_level_value = (group.tax_level_value + '').replace('.', ',')
            groups[group.name].taxable_amount_total += group.taxable_amount_total
            groups[group.name].tax_amount_total += group.tax_amount_total
            groups[group.name].total += group.total
          } else {
            groups[group.name] = {
              name: group.name,
              tax_level_value: (group.tax_level_value + '').replace('.', ','),
              taxable_amount_total: group.taxable_amount_total,
              tax_amount_total: group.tax_amount_total,
              total: group.total
            }
          }
        })
      })
      return Object.values(groups)
    },
    totalsPaymentMethdos () {
      const paymentMethods = {}
      this.data.forEach(device => {
        device.totals.clients.paymentMethods.forEach(method => {
          paymentMethods[method.name] = addToTotalsPaymentMethod(method, paymentMethods)
        })
        device.totals.endBuyers.paymentMethods.forEach(method => {
          paymentMethods[method.name] = addToTotalsPaymentMethod(method, paymentMethods)
        })
      })
      return Object.values(paymentMethods)
    },
    dailySummed () {
      const summed = {}
      this.daily.forEach(day => {
        Object.values(day.devices).forEach(device => {
          if (summed[device.name]) {
            const taxLevels = summed[device.name].taxLevels || {}
            Object.keys(device.taxLevels).forEach(taxLevelValue => {
              taxLevels[taxLevelValue] = {
                taxable_amount: taxLevels[taxLevelValue] && taxLevels[taxLevelValue].taxable_amount ? taxLevels[taxLevelValue].taxable_amount + device.taxLevels[taxLevelValue].taxable_amount : device.taxLevels[taxLevelValue].taxable_amount,
                tax_amount: taxLevels[taxLevelValue] && taxLevels[taxLevelValue].tax_amount ? taxLevels[taxLevelValue].tax_amount + device.taxLevels[taxLevelValue].tax_amount : device.taxLevels[taxLevelValue].tax_amount
              }
            })
            summed[device.name] = {
              date: device.date,
              maxInvoiceNumber: summed[device.name].maxInvoiceNumber > device.maxInvoiceNumber ? summed[device.name].maxInvoiceNumber : device.maxInvoiceNumber,
              minInvoiceNumber: summed[device.name].minInvoiceNumber < device.minInvoiceNumber ? summed[device.name].minInvoiceNumber : device.minInvoiceNumber,
              name: device.name,
              taxLevels,
              tax_amount_total: summed[device.name].tax_amount_total + device.tax_amount_total,
              taxable_amount_total: summed[device.name].taxable_amount_total + device.taxable_amount_total,
              total: summed[device.name].total + device.total
            }
          } else {
            summed[device.name] = device
          }
        })
      })
      return Object.values(summed)
    },
    dailySummedTaxableAmountTotalSum () {
      return this.dailySummed.reduce((total, device) => total + device.taxable_amount_total, 0)
    },
    dailySummedTaxLevelsSum () {
      const summedLevels = {}
      this.dailySummed.forEach(day => {
        Object.keys(day.taxLevels).forEach(taxLevelValue => {
          summedLevels[taxLevelValue] = {
            taxable_amount: summedLevels[taxLevelValue] && summedLevels[taxLevelValue].taxable_amount ? summedLevels[taxLevelValue].taxable_amount + day.taxLevels[taxLevelValue].taxable_amount : day.taxLevels[taxLevelValue].taxable_amount,
            tax_amount: summedLevels[taxLevelValue] && summedLevels[taxLevelValue].tax_amount ? summedLevels[taxLevelValue].tax_amount + day.taxLevels[taxLevelValue].tax_amount : day.taxLevels[taxLevelValue].tax_amount
          }
        })
      })
      return summedLevels
    },
    dailySummedTaxAmountTotalSum () {
      return this.dailySummed.reduce((total, device) => total + device.tax_amount_total, 0)
    },
    dailySummedTotalSum () {
      return this.dailySummed.reduce((total, device) => total + device.total, 0)
    },
    dailySummedNontaxableTotal () {
      const taxable95 = this.dailySummedTaxLevelsSum['9.5'] ? this.dailySummedTaxLevelsSum['9.5'].taxable_amount : 0
      const taxable22 = this.dailySummedTaxLevelsSum['22'] ? this.dailySummedTaxLevelsSum['22'].taxable_amount : 0
      const nontax = this.dailySummedTaxableAmountTotalSum - taxable95 - taxable22
      return nontax !== 0 ? nontax : null
    }
  },
  methods: {
    sloDate (date) {
      return moment(date).format('DD.MM.YYYY')
    },
    devicesTaxable_amount_total (devices) {
      return Object.values(devices).reduce((total, device) => total + device.taxable_amount_total, 0)
    },
    devicesTaxLevels95 (devices) {
      const taxAmount = Object.values(devices).reduce((total, device) => {
        const taxAmount = device.taxLevels && device.taxLevels['9.5'] && device.taxLevels['9.5'].tax_amount ? device.taxLevels['9.5'].tax_amount : 0
        return total + taxAmount
      }, 0)
      const taxableAmount = Object.values(devices).reduce((total, device) => {
        const taxAmount = device.taxLevels && device.taxLevels['9.5'] && device.taxLevels['9.5'].taxable_amount ? device.taxLevels['9.5'].taxable_amount : 0
        return total + taxAmount
      }, 0)
      return {
        tax_amount: taxAmount,
        taxable_amount: taxableAmount
      }
    },
    devicesTaxLevels22 (devices) {
      const taxAmount = Object.values(devices).reduce((total, device) => {
        const taxAmount = device.taxLevels && device.taxLevels['22'] && device.taxLevels['22'].tax_amount ? device.taxLevels['22'].tax_amount : 0
        return total + taxAmount
      }, 0)
      const taxableAmount = Object.values(devices).reduce((total, device) => {
        const taxAmount = device.taxLevels && device.taxLevels['22'] && device.taxLevels['22'].taxable_amount ? device.taxLevels['22'].taxable_amount : 0
        return total + taxAmount
      }, 0)
      return {
        tax_amount: taxAmount,
        taxable_amount: taxableAmount
      }
    },
    devicesTax_amount_total (devices) {
      return Object.values(devices).reduce((total, device) => total + device.tax_amount_total, 0)
    },
    devicesTotal (devices) {
      return Object.values(devices).reduce((total, device) => total + device.total, 0)
    },
    devicesNontaxableTotal (devices) {
      const taxable22 = this.devicesTaxLevels22(devices) ? this.devicesTaxLevels22(devices).taxable_amount : 0
      const taxable95 = this.devicesTaxLevels95(devices) ? this.devicesTaxLevels95(devices).taxable_amount : 0
      const nontax = this.devicesTaxable_amount_total(devices) - taxable22 - taxable95
      return nontax !== 0 ? nontax : null
    },
    nontaxableTotal (device) {
      const taxable22 = device.taxLevels['22'] ? device.taxLevels['22'].taxable_amount : 0
      const taxable95 = device.taxLevels['9.5'] ? device.taxLevels['9.5'].taxable_amount : 0
      const nontax = device.taxable_amount_total - taxable22 - taxable95
      return nontax !== 0 ? nontax : null
    }
  }
}

const addDeviceToDays = (device, days) => {
  device.daily.forEach(day => {
    if (!days[day.date]) {
      days[day.date] = {
        date: day.date
      }
    }
    if (!days[day.date].devices) {
      days[day.date].devices = {}
    }
    const taxLevels = {}
    day.taxGroups.taxLevels.forEach(level => {
      taxLevels[level.tax_level_value] = {
        taxable_amount: taxLevels[level.tax_level_value] && taxLevels[level.tax_level_value].taxable_amount ? taxLevels[level.tax_level_value].taxable_amount + level.taxable_amount : level.taxable_amount,
        tax_amount: taxLevels[level.tax_level_value] && taxLevels[level.tax_level_value].tax_amount ? taxLevels[level.tax_level_value].tax_amount + level.tax_amount : level.tax_amount
      }
    })
    days[day.date].devices[device.name] = {
      date: day.date,
      name: device.name,
      minInvoiceNumber: day.minInvoiceNumber,
      maxInvoiceNumber: day.maxInvoiceNumber,
      taxable_amount_total: day.taxGroups.taxable_amount_total,
      tax_amount_total: day.taxGroups.tax_amount_total,
      total: day.totalSum,
      taxLevels
    }
  })
  return days
}

const addToTotalsPaymentMethod = (method, paymentMethods) => {
  if (paymentMethods[method.name]) {
    return {
      name: method.name,
      taxableAmountTotal: paymentMethods[method.name].taxableAmountTotal + method.taxable_amount_total,
      taxLevels: addToTotalsPaymentMethodTaxLevels(method, paymentMethods[method.name]),
      taxAmountTotal: paymentMethods[method.name].taxAmountTotal + method.tax_amount_total,
      total: paymentMethods[method.name].total + method.total
    }
  } else {
    return {
      name: method.name,
      taxableAmountTotal: method.taxable_amount_total,
      taxLevels: addToTotalsPaymentMethodTaxLevels(method),
      taxAmountTotal: method.tax_amount_total,
      total: method.total
    }
  }
}

const addToTotalsPaymentMethodTaxLevels = (method, oldData) => {
  if (oldData) {
    const taxLevels = oldData.taxLevels
    method.tax_levels.forEach(level => {
      taxLevels[level.tax_level_value] = taxLevels[level.tax_level_value] ? taxLevels[level.tax_level_value] + level.tax_amount : level.tax_amount
    })
    return taxLevels
  } else {
    const taxLevels = {}
    method.tax_levels.forEach(level => {
      taxLevels[level.tax_level_value] = level.tax_amount
    })
    return taxLevels
  }
}
</script>

<style lang="scss">
.theme--light.v-application .report {
  background-color: white;
  font-size: 10px;
}
</style>

<style lang="scss" scoped>
.report {
  padding: 30px 20px;
}
.document-title {
  margin-bottom: 30px;
  text-align: center;
}
.table-title {
  border: 1px solid black;
  text-align: center;
  background-color: #eaeaea;
  font-weight: bold;
  font-size: 110%;
  margin-bottom: -1px;
}
.table-header,
.table-footer {
  border: 1px solid black;
  background-color: #e5e5e5;
  font-weight: bold;
  font-size: 110%;
}
.table-header-daily,
.table-footer-daily {
  border: 1px solid black;
  background-color: #e5e5e5;
  font-size: 110%;
}
.devider {
  padding-top: 0px;
  margin-top: 0px;
  margin-bottom: 10px;
  border-top: 1px solid black;
}

  .col {
    padding-top: 5px;
    padding-bottom: 5px;
  }

.full-width {
  width: 100%;
}
</style>
